<!-- 模板 -->
<template>
    <div class="card-box">
        <div class="card" :class="active(2) || active(3)">
            <div class="card-main">
                <!-- 手机基本信息 -->
                <div class="section-box">
                    <div class="card-section" :class="active(1)">
                        <div class="firsttab">
                            <div class="card-content basicinfo">
                                <!-- 手机基本信息 -->
                                <div>
                                    <div class="card-subtitle">手机基本信息：</div>
                                    <span style="color: #fc642d">{{ sharedData.conditionPre }}</span>
                                    <p>
                                        手机品牌: {{ sharedData.brand }}&emsp;
                                        <span style="color: #296dff">
                                            {{ sharedData.purchaseChannel }}
                                        </span>
                                    </p>
                                    <p>手机型号: {{ sharedData.model }}&emsp;</p>
                                    <p>
                                        存储:<span v-if="sharedData.ram"> {{ sharedData.ram }} + </span>
                                        <span v-if="sharedData.storage">
                                            {{ sharedData.storage }}
                                        </span>
                                        <span style="margin-left: 55px">颜色: {{ sharedData.color }}</span>
                                        <span style="margin-left: 55px">等级: {{ sharedData.grade }}</span>
                                    </p>
                                    <p v-if="sharedData.historyFlag">
                                        是否买到:
                                        <span style="background-color: #fc642d; color: white">{{ sharedData.isSuccess }}</span>
                                    </p>
                                    <p v-if="sharedData.transactionPrice">
                                        成交价:
                                        <span style="color: white; background-color: green"> ¥{{ sharedData.transactionPrice }}</span>
                                    </p>
                                    <p>
                                        起拍价:
                                        <span style="color: white; background-color: red"> ¥{{ sharedData.upsetPrice }}</span>
                                    </p>
                                    <p>
                                        验机码:
                                        <span>{{ sharedData.stickCode }}</span>
                                        <span style="margin-left: 55px">系统批次: {{ sharedData.patch }}</span>
                                    </p>
                                </div>
                                <!-- 质量描述 -->
                                <div style="">
                                    <h3>质量描述：</h3>
                                    <div
                                        :class="{
                                            active: !sharedData.sources === '回收宝',
                                            inactive: sharedData.sources === '回收宝',
                                        }"
                                        style="
                                            overflow-y: auto; /* Enables vertical scrolling */
                                            padding: 10px; /* Optional padding */
                                            border: 1px solid #ddd; /* Optional border */
                                            background-color: #f9f9f9; /* Optional background color */
                                        ">
                                        <p v-for="(value, key) in parseQualityDesc(sharedData.qualityDesc)" :key="key">
                                            <span style="color: #296dff">{{ key }}:</span>
                                            {{ value }}
                                        </p>
                                    </div>
                                </div>
                                <!-- 附加说明 -->
                                <div style="" v-if="sharedData.sources === '采货侠'">
                                    <h3>附加说明</h3>
                                    <div
                                        style="
                                            max-height: 200px; /* Adjust the height as needed */
                                            overflow-y: auto; /* Enables vertical scrolling */
                                            padding: 10px; /* Optional padding */
                                            border: 1px solid #ddd; /* Optional border */
                                            background-color: #f9f9f9; /* Optional background color */
                                        ">
                                        <p v-for="(value, key) in parseQualityDesc(sharedData.allJson)" :key="key">
                                            <span style="color: #296dff">{{ key }}:</span>
                                            {{ value }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <!--  画廊 -->
                            <div class="gallery-box">
                                <h3>图片信息</h3>
                                <div class="gallery">
                                    <!-- 正常图 -->
                                    <div class="thumbnails">
                                        <div
                                            v-for="(photo, index) in creatlist1()"
                                            :src="photo"
                                            :key="index"
                                            @click="activePhoto = index"
                                            :class="{
                                                active: activePhoto == index,
                                            }"
                                            style="background-color: #ddd"
                                            :style="'background-image: url(' + photo + ')'"></div>
                                    </div>
                                    <hr />
                                    <!-- 瑕疵图 -->
                                    <div class="thumbnails">
                                        <div
                                            v-for="(photo, index) in creatlist()"
                                            :src="photo"
                                            :key="index"
                                            @click="activePhoto = index + creatlist1().length"
                                            :class="{
                                                active: activePhoto == index + creatlist1().length,
                                            }"
                                            :style="'background-image: url(' + photo + ')'"></div>
                                    </div>

                                    <!-- 大图 -->
                                    <div style="display: flex; justify-content: center; width: 100%">
                                        <div class="active-photo" :style="'background-image: url(' + creatlist3()[activePhoto] + ');'" @click="toggleImage">
                                            <button type="button" aria-label="Previous Photo" class="previous" @click="previousPhoto()">◀</button>
                                            <button type="button" aria-label="Next Photo" class="next" @click="nextPhoto()">▶</button>
                                        </div>
                                    </div>
                                    <el-image-viewer :teleported="true" v-if="isVisible" :url-list="[creatlist3()[activePhoto]]" @close="bighiden" :hide-on-click-modal="true" />
                                </div>
                            </div>
                        </div>
                    </div>

                    <!--历史记录-->
                    <div class="card-section" :class="active(2)">
                        <div class="card-content">
                            <div class="card-subtitle">历史成交</div>
                            <div class="card-timeline">
                                当前参数是:{{ sharedData.brand }} {{ sharedData.model }} {{ sharedData.ram }}
                                {{ sharedData.storage }}
                                {{ sharedData.color }}
                                {{ sharedData.grade }}
                                <div class="chartdiv" ref="myChart" />
                            </div>
                        </div>
                    </div>

                    <!--第三页-->
                    <div class="card-section" :class="active(3)">
                        <!-- 转转估价数据 -->
                        <div class="card-content" style="height: 45%">
                            <div v-if="typeof sharedData.historyFlag === 'undefined'" style="height: 100%">
                                <!-- 标题 -->
                                <div class="card-subtitle">
                                    <div style="display: flex; justify-content: space-between; align-items: center">
                                        <span>
                                            <span @click="justGetZZprice">
                                                <el-icon>
                                                    <Refresh />
                                                </el-icon>
                                            </span>
                                            转转估价信息 ：
                                        </span>
                                        <el-button @click="regetzzprice" text style="color: black"> 更新价格 </el-button>
                                    </div>
                                </div>
                                <!-- 表格 -->
                                <el-table :data="informationList" border style="width: 100%; height: 100%; overflow-y: auto" v-loading="loading">
                                    <el-table-column prop="quality" label="成色" />
                                    <el-table-column prop="zzLowestSalePrice" label="最低销售" />
                                    <el-table-column prop="tenpercenteearnratemaxbiddingprice" label="10%利润竞拍" />
                                    <el-table-column prop="couponfee" label="对应红包" />
                                    <el-table-column prop="endprice" label="最低结算" />
                                    <el-table-column prop="maxbiddingprice" label="最高竞拍" />
                                    <el-table-column prop="min5avgsaleprice" label="最低前五销售" />
                                    <el-table-column prop="min5avgendprice" label="最低前五结算" />
                                </el-table>
                            </div>
                        </div>
                        <!-- 下单数据 -->
                        <div class="card-content bn" v-loading="getPriceLoading" style="height: auto">
                            <!-- 标题 -->
                            <div class="card-subtitle">
                                立即在采货平台下单
                                <el-link @click="getRedPacket()" type="warning">红包规则</el-link>
                            </div>
                            <!-- 红包弹窗 -->
                            <el-dialog width="100%" v-model="dialogTableVisible" title="红包规则">
                                <el-table :data="redPacket" border style="width: 100%">
                                    <el-table-column prop="category" label="红包规则" width="180" />
                                    <el-table-column prop="priceGradient" label="起始价" width="180" />
                                    <el-table-column prop="burdenFee" label="红包" />
                                    <el-table-column prop="startTime" label="开始时间" />
                                    <el-table-column prop="endTime" label="结束时间" />
                                </el-table>
                            </el-dialog>
                            <!-- 下单数据 -->
                            <div class="info-box">
                                <!-- 价格信息 -->
                                <div class="card-contact-wrapper left">
                                    <!-- 预估成色 -->
                                    <div class="card-contact">
                                        <img src="@/assets/images/change_skin.png" alt="Change Skin Image" />
                                        <span style="display: flex">
                                            预估成色：
                                            <div style="color: green">
                                                <div v-if="sharedData.conditionPre">
                                                    {{ sharedData.conditionPre == 0 ? "0新,不进卖场" : sharedData.conditionPre + "新" }}
                                                </div>
                                                <div v-else>根据瑕疵描述,无法判断成色</div>
                                            </div>
                                        </span>
                                    </div>
                                    <!-- 起拍价 -->
                                    <div class="card-contact">
                                        <img src="@/assets/images/change_skin.png" alt="Change Skin Image" />
                                        <span style="display: flex">
                                            起拍价：
                                            <div style="color: red">¥{{ sharedData.upsetPrice }}</div>
                                        </span>
                                    </div>
                                    <!-- 拍机堂 -->
                                    <div class="card-contact">
                                        <img :src="require('@/assets/images/change_skin.png')" alt="Change Skin Image" />
                                        <span style="display: flex">
                                            拍机堂：
                                            <div style="color: black">
                                                <!-- <span v-if="pjtPrice.goingCode === 1"> {{ pjtPrice.going }} </span> -->
                                                <div>
                                                    <div v-if="isFlags">
                                                        {{ pjtPrice }}
                                                    </div>
                                                    <div v-else>
                                                        <div v-if="pjtPriceM == undefined || pjtPriceM == '' || !pjtPriceM">
                                                            <button @click="freshpjt()">请刷新..</button>
                                                        </div>
                                                        <div v-else>¥{{ pjtPriceM }}</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- <div v-else style="color: black">-</div> -->
                                        </span>
                                    </div>
                                    <!-- 上次出价 -->
                                    <div class="card-contact">
                                        <img :src="require('@/assets/images/change_skin.png')" alt="Change Skin Image" />
                                        <span style="display: flex">
                                            上次出价：
                                            <div
                                                style="color: green; display: flex"
                                                v-if="typeof mytodayprice !== 'undefined' && mytodayprice !== null && mytodayprice.amount !== null">
                                                ¥ {{ mytodayprice.amount }}
                                            </div>
                                            <div v-else>-</div>
                                        </span>
                                    </div>
                                    <!-- 修改出价 -->
                                    <div class="card-contact" v-if="canbuyData">
                                        <img :src="require('@/assets/images/change_skin.png')" alt="Change Skin Image" />
                                        <div @click="changeBiddingprice()" style="margin-right: 12px">
                                            <span class="ss">修改出价</span>
                                        </div>
                                        <el-input ref="yy" type="number" v-model="myBiddingprice" :min="0" v-if="true" :style="{ width: '200px' }" @blur="checkmybiddingprice()" />
                                    </div>

                                    <!-- 选择下单账号 -->
                                    <div class="card-contact" v-if="canbuyData">
                                        <img :src="require('@/assets/images/change_skin.png')" alt="Change Skin Image" />

                                        <span style="margin-right: 12px">下单账号</span>
                                        <el-select v-model="search" placeholder="选择下单账号" style="width: 200px" value-key="userAccount">
                                            <el-option
                                                v-for="platform in orderAccountList"
                                                :key="platform.userAccount"
                                                :label="platform.userAccount"
                                                :value="platform"
                                                :style="{
                                                    backgroundColor: platform.accountStatus === 1 ? 'red' : '',
                                                    color: platform.accountStatus === 1 ? 'white' : '',
                                                }" />
                                        </el-select>
                                    </div>
                                    <!-- 当前出价--出价按钮 -->
                                    <div style="display: flex">
                                        <div style="font-size: x-large" v-if="canbuyData">当前出价: ¥{{ suprice }}</div>

                                        <!-- 下单按钮 -->
                                        <button v-if="canbuyData" class="contact-me" @click="buyit()">
                                            <span style="font-size: larger">立即下单</span>
                                        </button>
                                    </div>
                                    <p v-if="testshow">{{ filterItems }}</p>
                                    <!-- 瑕疵信息 -->
                                </div>
                                <div class="right">
                                    <div class="one-piece">
                                        <div class="ptj-choose-title">
                                            <div class="title-box">
                                                <span class="block"></span>
                                                <span>拍机堂全部选项：</span>
                                            </div>
                                            <el-button style="margin-right: 15px" @click="getPrice" v-if="allChoose.length !== 0">查 价</el-button>
                                        </div>
                                        <div class="select-box" v-loading="loadingChoose">
                                            <div :key="choose.step" v-for="choose in allChoose" class="select-list">
                                                <div class="choose-title">
                                                    {{ choose.stepName }}
                                                </div>
                                                <div class="one-choose" :key="item.id" v-for="item in choose.properties">
                                                    <div class="title">
                                                        {{ item.name }}
                                                    </div>
                                                    <el-select v-model="selectForm[item.id].value" @change="(value) => selectChoose(value, item.id)" class="select">
                                                        <el-option v-for="i in item.pricePropertyValues" :key="i.id" :label="i.value" :value="i.id" />
                                                    </el-select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 底部按钮 -->
                <div class="card-buttons">
                    <button :class="active(1)" @click="selectTab(1)">关于</button>
                    <button
                        :class="active(2)"
                        @click="
                            selectTab(2);
                            getdata();
                        "
                        v-if="typeof sharedData.historyFlag === 'string'">
                        历史价格
                    </button>
                    <button
                        :class="active(3)"
                        @click="
                            selectTab(3)
                            // getPJTChoose();
                        "
                        v-if="typeof sharedData.historyFlag === 'undefined'">
                        查价下单
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { debounce } from "@/utils/untilTwo";
    import axios from "axios";
    import { ElMessage } from "element-plus";
    import swal from "sweetalert2";
    import { getCurrentInstance } from "vue";
    import { mapGetters } from "vuex";

    export default {
        name: "detailsCardView",
        props: {
            orderAccountList: {
                type: Array,
                default: () => [],
            },
            pjtNewPrice: {
                type: String,
                default: undefined,
            },
            // conditionnewPre: {
            //     type: String,
            //     default: undefined,
            // },
            isFlag: {
                type: Boolean,
            },
        },
        created() {
            this.suprice = this.sharedData.upsetPrice;
            this.canbuy = this.canbuyData;
            this.pjtPriceM = "";
        },
        data() {
            return {
                getPriceLoading: false,
                testshow: false,
                // 画廊
                activePhoto: 0,
                activeImg: 0,
                isVisible: false,

                nickname: localStorage.getItem("nickname"),
                nid: localStorage.sa,

                platformURL: "/api/systemPlatformInfo/platForm/init",
                zzpriceURL: "/api/systemEvaluatePrice/queryByPage",

                // pjtpriceURL: "/api/productEvaluateResult/queryProductEvaluateInfoByPatchAndStickCode",
                buyitURL: "/api/orderDetails/add",
                extraBuyURL: "/api/orderDetails/currentOrderList",
                // goestimatedURL: "/api/productEvaluateResult/sendProductEvaluateInfo",
                goestimatedURL: "/api/PjtEvaluateDesc/sendAndRefreshEvaluatePriceByParam",

                search: {
                    id: -1,
                    userAccount: -1,
                },

                // el 表格
                tableData: [],
                tempPlatform: {
                    name: "",
                    id: "",
                },

                index: 1,
                // 图片放大
                showPopup: false,
                currentImageUrl: "",

                // 折线相关
                demo: null,
                getdataURL: "/api/historyAuction/queryHistoryAuctionInfo",
                getallOrderURL: "/api/orderDetails/currentOrderList",
                title: "",
                echarts: getCurrentInstance().appContext.config.globalProperties.$echarts,
                input_xaxis: "",
                input_yaxis: 0,

                // pjtPrice: { going: "正在为您查价..", goingCode: 1 },
                mytodayprice: null, // 我的今日出价
                defaultBiddingprice: null,
                myBiddingprice: null, // 我的出价为0
                suprice: null,
                description: null, // 质量描述,
                // orderAccountList: this.props.orderAccountList
                dialogTableVisible: false,
                redPacket: [], //红包规则
                informationList: [], //估价信息
                information: [], // 成色下拉框数据
                quality: "", //平台ID
                loading: false,
                pjtPriceM: "",
                isFlags: true,
                allChoose: [],
                defaultChoose: [],
                selectForm: [],
                loadingChoose: true,
                pjtPrice: 0,
                conditionpre: "无法判断成色!",
            };
        },
        watch: {
            myBiddingprice(newVal) {
                if (newVal) {
                    this.suprice = newVal;
                } else {
                    this.suprice = this.sharedData.upsetPrice;
                }
            },
            pjtNewPrice: {
                handler(newValue) {
                    if (newValue) {
                        this.pjtPriceM = newValue;
                        // 处理新数据
                    } else {
                        this.pjtPriceM = "";
                    }
                },
                deep: true, // 开启深度监听
            },

            isFlag(newVal) {
                this.isFlags = newVal;
            },
        },
        methods: {
            getPrice() {
                const _this = this;
                this.getPriceLoading = true;
                let idList = [];
                _this.selectForm.forEach((item) => {
                    idList.push(item.id);
                });
                let returnJson = {
                    id: this.sharedData.id,
                    pjtDescParam: JSON.stringify({
                        productId: this.sharedData.id,
                        post_id_li: idList,
                    }),
                };
                axios
                    .post("/api/PjtEvaluateDesc/sendAndRefreshEvaluatePriceByParam", returnJson, {
                        headers: {
                            satoken: localStorage.getItem("sa"),
                        },
                    })
                    .then((res) => {
                        _this.getPriceLoading = false;
                        if (res.data.code === 200) {
                            if (res.data.data.pjtPrice === undefined) {
                                _this.pjtPrice = 0;
                                _this.$message.error("未查询到估价");
                                return;
                            }
                            _this.$message.success("查价成功，已更新价格");
                            _this.pjtPrice = res.data.data.pjtPrice;
                        } else {
                            _this.$message.error(res.data.message);
                        }
                    });
            },
            // 提取函数来查找匹配的项
            getDefaultItem(pricePropertyValues, defaultChoose) {
                return pricePropertyValues.find((value) => defaultChoose.includes(value.id));
            },
            initializeSelectForm() {
                this.allChoose.forEach((choose) => {
                    choose.properties.forEach((item) => {
                        // 查找是否有匹配的 defaultChoose ID
                        const defaultItem = this.getDefaultItem(item.pricePropertyValues, this.defaultChoose);
                        if (defaultItem) {
                            // 如果找到匹配的项，则设置为选择表单
                            this.selectForm[item.id] = {
                                id: defaultItem.id,
                                value: "● " + defaultItem.value,
                            };
                        } else {
                            // 如果没有找到匹配的项，则使用第一个作为默认
                            this.selectForm[item.id] = {
                                id: item.pricePropertyValues[0].id,
                                value: item.pricePropertyValues[0].value,
                            };
                        }
                    });
                });

                this.loadingChoose = false;
            },
            selectChoose(value, id) {
                this.selectForm[id].id = value;
                const _this = this;
            },
            getPJTChoose() {
                const _this = this;
                _this.loadingChoose = true;
                //  获取所有选项前，将选项数据清空
                _this.allChoose = [];
                _this.defaultChoose = [];
                axios
                    .get("/api/PjtEvaluateDesc/queryDataByParam?id=" + this.sharedData.id, {
                        headers: {
                            satoken: localStorage.getItem("sa"),
                        },
                    })
                    .then((res) => {
                        // let defaultChoose = JSON.parse(res.data.data.pjtDescParam.replaceAll("'","\"")).post_id_li;
                        // if (res.data.code !== 200 || res.data.data === undefined || res.data.data.allJson === undefined) {
                        //     _this.$message.error("暂无拍机堂选项数据");
                        //     _this.loadingChoose = false;
                        //     return;
                        // }

                        // _this.allChoose = JSON.parse(res.data.data.allJson).data;
                        if (res.data.data.postIdLiShort !== undefined) {
                            this.defaultChoose = JSON.parse(res.data.data.postIdLiShort).short_post_id_li;
                        }
                        //  初始化数据
                        this.initializeSelectForm();
                    });
            },
            regetzzprice: debounce(function () {
                this.loading = true;
                axios
                    .get(this.zzpriceURL, {
                        headers: {
                            satoken: localStorage.sa,
                        },
                        params: {
                            id: this.sharedData.id,
                            requestType: "refresh",
                        },
                    })
                    .then((res) => {
                        this.loading = false;
                    });
            }),
            //获取转转估价列表
            justGetZZprice() {
                if (this.sharedData == null) {
                    this.$message.error("获取商品信息失败");
                    return;
                }
                axios
                    .get(this.zzpriceURL, {
                        headers: {
                            satoken: localStorage.sa,
                        },
                        params: {
                            id: this.sharedData.id,
                        },
                    })
                    .then((res) => {
                        this.loading = false;
                        this.informationList = res.data.data.result;
                    })
                    .catch((error) => {
                        this.data = error;
                        this.$message.error("获取数据出错:", error);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },
            getMyTodayPrice() {
                if (this.sharedData === null) {
                    this.$message.error("暂未查询到该数据");
                }
                axios
                    .get(this.getallOrderURL, {
                        headers: {
                            satoken: localStorage.sa,
                        },
                        params: {
                            pageNo: this.currentPage,
                            pageSize: this.itemsPerPage,
                            stickCode: this.sharedData.stickCode,
                        },
                    })
                    .then((response) => {
                        this.mytodayprice = response.data.data.result[0];
                        this.allpages = response.data.data.total;
                        this.tableData = response.data.data.result;
                    })
                    .catch((error) => {
                        this.data = error;
                        console.error("获取数据出错:", error);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },

            // 获取转转估价
            getZZprice() {
                axios
                    .get(this.zzpriceURL, {
                        headers: {
                            satoken: localStorage.sa,
                        },
                        params: {
                            id: this.sharedData.id,
                        },
                    })
                    .then((res) => {
                        this.loading = false;
                        this.pjtPrice = {
                            evaluateResultPrice: res.data.data.evaluateResultPrice,
                            evaluateResultDescription: res.data.data.evaluateResultDescription,
                        };
                    });
            },

            /*正常图片的逻辑*/
            creatImgUrl() {
                const list = this.parseImgUrls(this.sharedData.rawAllImgUrl);
                return list;
            },
            //处理图片显示
            parseImgUrls(defectUrl) {
                try {
                    return defectUrl.split("|");
                } catch (e) {
                    return [];
                }
            },
            // 切换下一张图片
            nextImg() {
                if (this.activeImg + 1 < this.creatImgUrl().length) {
                    this.activeImg++;
                }
            },
            // 切换上一张图片
            previousImg() {
                if (this.activeImg - 1 >= 0) {
                    this.activeImg--;
                }
            },

            // 切换图片
            creatlist1() {
                return this.sharedData.rawAllImgUrl ? this.sharedData.rawAllImgUrl.split("|") : [];
            },
            creatlist() {
                const obj = this.parseDefectUrls(this.sharedData.rawDefectUrl ? this.sharedData.rawDefectUrl : []);
                return Object.values(obj).flatMap((value) => (value.includes("|") ? value.split("|") : [value]));
            },
            creatlist3() {
                //const obj = this.parseDefectUrls(this.sharedData.rawDefectUrl ? this.sharedData.rawDefectUrl.split("|") : []);
                const obj = this.parseDefectUrls(this.sharedData.rawDefectUrl ? this.sharedData.rawDefectUrl : []);
                //const list = Object.values(obj).flat();
                const list = Object.values(obj).flatMap((value) => (value.includes("|") ? value.split("|") : [value]));
                const list2 = this.sharedData.rawAllImgUrl ? this.sharedData.rawAllImgUrl.split("|") : [];
                return list2.concat(list);
            },
            // 隐藏大图
            bighiden() {
                this.isVisible = false;
            },

            nextPhoto() {
                if (this.activePhoto + 1 < this.creatlist3().length) {
                    this.activePhoto++;
                } else {
                    // 如果已经是最后一张照片，则不做任何变化，或者根据需求处理
                    // 如果需要循环，则可以设置为第一张照片： this.activePhoto = 0;
                }
            },
            previousPhoto() {
                if (this.activePhoto - 1 >= 0) {
                    this.activePhoto--;
                } else {
                    // 如果已经是第一张照片，则不做任何变化，或者根据需求处理
                    // 如果需要循环，则可以设置为最后一张照片： this.activePhoto = this.photos.length - 1;
                }
            },

            toggleImage() {
                this.isVisible = !this.isVisible;
            },

            // 下单
            buyit() {
                if (typeof this.search === "undefined" || this.search === null || this.search.id === -1) {
                    ElMessage.error("您还未选择下单账户!");
                    return;
                }
                swal.fire({
                    title: "确认出价信息",
                    html: `
				<div style="text-align: left;">
				<p>系统账户: ${this.nickname}</p>
				<p>平台: ${this.sharedData.sources}</p>
				<p>平台账号: ${this.search.userAccount}</p>
				<p>验机码: ${this.sharedData.stickCode}</p>
				<p>出价: ¥${this.suprice}</p>
				</div>
				`,
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                }).then((result) => {
                    if (result.isConfirmed) {
                        // 用户点击了确认按钮，执行更新操作
                        const headers = {
                            satoken: localStorage.sa,
                        };
                        const body = {
                            accountId: this.search.id,
                            amount: this.suprice,
                            stickCode: this.sharedData.stickCode,
                            patch: this.sharedData.patch,
                            infoId: this.sharedData.infoId,
                        };
                        axios
                            .post(this.buyitURL, body, {
                                headers,
                            })
                            .then((response) => {
                                if (response.data.code == 200) {
                                    // this.$emit("call-closePopup");
                                    setTimeout(() => {
                                        this.loading = true;
                                        this.getTableData(response.data, this.sharedData.patch, this.sharedData.stickCode);
                                    }, 1000);
                                }
                            })
                            .catch((error) => {
                                console.error("Error:", error);
                            });
                    } else {
                        ElMessage.info("您取消了支付");
                    }
                });
            },

            // 查看平台出价结果
            getTableData(o, p, s) {
                if (o.success === false) {
                    swal.fire({
                        title: "发生了一些错误..",
                        html: `
                    <div style="text-align: left;">
                        出价错误:${o.data || "未知错误"}
                        </div>
                        `,
                        icon: "error",
                        showCancelButton: false,
                        confirmButtonColor: "#3085d6",
                        confirmButtonText: "确定",
                    });
                    return;
                }

                axios
                    .get(this.extraBuyURL, {
                        headers: {
                            satoken: localStorage.sa,
                        },
                        params: {
                            patch: p,
                            stickCode: s,
                        },
                    })
                    .then((response) => {
                        let res = response.data.data.result[0];
                        if (res.orderResult !== "success" && typeof res.orderResult !== "undefined") {
                            swal.fire({
                                title: "发生了一些错误..",
                                html: `
                                <div style="text-align: left;">
                                ${res.sources}平台提示:${res.orderResult || "未知错误"}
                                    </div>
                                    `,
                                icon: "error",
                                showCancelButton: false,
                                confirmButtonColor: "#3085d6",
                                confirmButtonText: "确定",
                            });
                        }
                    })
                    .then(() => {
                        this.$emit("call-closePopup");
                        this.loading = false;
                    })
                    .catch((error) => {
                        this.data = error;
                        console.error("获取数据出错:", error);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },

            // 输入新的出价
            changeBiddingprice() {
                this.$nextTick(() => {
                    if (this.$refs.yy) {
                        this.$refs.yy.$refs.input.focus();
                    }
                });
            },

            // 检查输入出价
            checkmybiddingprice() {
                if (this.myBiddingprice === null || parseInt(this.myBiddingprice) <= 0 || this.myBiddingprice === "") {
                    if (this.myBiddingprice === "") {
                    }
                    this.myBiddingprice = null;
                    return;
                }
            },

            // 获取历史价格列表
            getdata() {
                axios
                    .get(this.getdataURL, {
                        headers: {
                            satoken: localStorage.sa,
                        },
                        params: {
                            brand: this.sharedData.brand,
                            model: this.sharedData.model,
                            ram: this.sharedData.ram,
                            storage: this.sharedData.storage,
                            color: this.sharedData.color,
                            grade: this.sharedData.grade,
                        },
                    })
                    .then((response) => {
                        // 输出响应数据
                        this.demo = response.data.data.result;
                        this.create_axis();
                    }).catch;
            },
            // 生成折线图
            create_axis() {
                //3.初始化实例对象 echarts.init(dom容器)
                var data_xAxis = [];
                var data_yAxis = [];
                for (var i = this.demo.length - 1; i >= 0; i--) {
                    var patch = this.demo[i].patch;
                    var transactionPrice = this.demo[i].transactionPrice;

                    // 检查 transactionPrice 是否为 undefined
                    if (typeof transactionPrice !== "undefined") {
                        data_xAxis.push(patch);
                        data_yAxis.push(transactionPrice);
                    }
                }

                var dom = this.$refs["myChart"]; // 获取dom节点
                var myChart = this.echarts.getInstanceByDom(dom);

                // 如果已经存在实例，则可以使用 existingChart 来更新数据或其他操作
                if (myChart) {
                    data_xAxis = [];
                    data_yAxis = [];
                    for (i = this.demo.length - 1; i >= 0; i--) {
                        patch = this.demo[i].patch;
                        transactionPrice = this.demo[i].transactionPrice;

                        // 检查 transactionPrice 是否为 undefined
                        if (typeof transactionPrice !== "undefined") {
                            data_xAxis.push(patch);
                            data_yAxis.push(transactionPrice);
                        }
                    }

                    // 更新图表数据
                    myChart.setOption({
                        xAxis: {
                            data: data_xAxis,
                        },
                        series: [
                            {
                                data: data_yAxis,
                            },
                        ],
                    });
                } else {
                    // 否则，进行初始化
                    var chart = this.echarts.init(dom);
                    //4.指定配置项和数据
                    var option = {
                        title: {
                            text: this.title,
                        },
                        tooltip: {},
                        xAxis: {
                            type: "category",
                            boundaryGap: false,
                            data: data_xAxis,
                            axisLine: {
                                lineStyle: {
                                    color: "black", // 设置横轴颜色为黑色
                                },
                            },
                        },
                        yAxis: {
                            type: "value",
                            axisLine: {
                                lineStyle: {
                                    color: "grey", // 设置横轴颜色为黑色
                                },
                            },
                            splitLine: {
                                // 设置 y 轴网格线
                                lineStyle: {
                                    color: "black", // 设置网格线颜色为黑色
                                },
                            },
                        },
                        legend: {},
                        series: [
                            {
                                symbolSize: 10, // 设置点的大小为10
                                name: "成交价格",
                                data: data_yAxis,
                                type: "line",
                                areaStyle: {
                                    color: "pink", // 设置面积颜色
                                },
                                // label标签用来显示每个点的值
                                label: {
                                    fontSize: 19,
                                    show: true,
                                    position: "top",
                                },
                                smooth: true,

                                lineStyle: {
                                    // 设置线条样式
                                    color: "red", // 设置线条颜色为红色
                                },
                            },
                        ],
                        axisPointer: {
                            lineStyle: {
                                color: "black", // 坐标系边框线颜色为黑色
                            },
                        },
                    };
                    //5.将配置项设置给echarts实例对象，使用刚指定的配置项和数据显示图表。
                    chart.setOption(option);
                }
            },
            // resetpjtPrice() {
            //     this.pjtPrice = { going: "正在为您查价..", goingCode: 1 };
            // },
            resetzzprice() {
                this.informationList = [];
            },
            // 切换视图
            selectTab(index) {
                // this.resetpjtPrice();
                this.resetzzprice();
                this.index = index;
                if (index === 3) {
                    this.justGetZZprice();
                    this.getMyTodayPrice();
                    // this.getPJTprice();
                    this.suprice = this.sharedData.upsetPrice;
                    this.myBiddingprice = null;
                    this.search = this.orderAccountList[0];
                }
                if (index === 1) {
                    this.activePhoto = 0;
                    this.activeImg = 0;
                }
            },

            // 刷新拍机堂
            freshpjt() {
                // 重新发送请求
                axios
                    .post(
                        this.goestimatedURL,
                        {
                            id: this.sharedData.id,
                        },
                        {
                            headers: {
                                satoken: localStorage.sa,
                            },
                        }
                    )
                    .then((res) => {
                        if (res.data.code == 200) {
                            this.isFlags = false;
                            this.pjtPriceM = res.data.data.pjtPrice;

                            this.$emit("callParentMethod", this.pjtPriceM);
                        } else {
                            this.$message.error(res.data.data);
                        }

                        // this.resetpjtPrice();
                        // this.resetzzprice();
                        // this.getPJTprice();
                    });
            },

            // 视图响应
            active(index) {
                return index === this.index ? "is-active" : "";
            },

            // 处理 \"
            parseDefectUrls(defectUrl) {
                try {
                    const parsed = JSON.parse(defectUrl);

                    Object.keys(parsed).forEach((key) => {
                        parsed[key] = parsed[key];
                    });
                    return parsed;
                } catch (e) {
                    return [];
                }
            },
            // 处理 \"
            parseQualityDesc(desc) {
                try {
                    const quality = JSON.parse(desc);
                    return quality;
                } catch (e) {
                    return desc;
                }
            },
            //查询红包
            getRedPacket() {
                this.dialogTableVisible = true;
                this.queryRed();
            },
            queryRed() {
                // patch 只在暗拍间隙生效
                axios
                    .get("/api/zztCouponTable/queryZztCouponTable", {
                        headers: {
                            satoken: localStorage.sa,
                        },
                        params: {},
                    })
                    .then((res) => {
                        this.redPacket = res.data.data.result;
                    });
            },
        },
        mounted() {
            this.pjtPriceM = "";
            //画廊
            this.activePhoto = 0;
            this.activeImg = 0;
            document.addEventListener("keydown", (event) => {
                if (event.key === "ArrowLeft") {
                    this.previousPhoto();
                }
                if (event.key === "ArrowRight") {
                    this.nextPhoto();
                }
            });
        },

        computed: {
            ...mapGetters("shared", ["getSharedData", "getCanbuyData"]),
            sharedData() {
                return this.getSharedData;
            },
            canbuyData() {
                return this.getCanbuyData;
            },
            filterItems: function () {
                return this.tableData.filter((item) => {
                    return item.accountTypeName.match(this.sharedData.sources);
                });
            },
        },
    };
</script>

<style lang="scss" scoped>
    @use "sass:color";
    // 画廊
    $brand: #5c4084;

    .gallery-box {
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        width: 100%;
        height: 100%;
    }

    .el-table--border .el-table__inner-wrapper:after,
    .el-table--border:after,
    .el-table--border:before,
    .el-table__inner-wrapper:before {
        background-color: white !important;
    }

    .gallery {
        width: 90%;
        flex-direction: column;
        background-color: #ffffff;
        padding: 4px;
        border-radius: 8px;
        justify-content: center;

        .active-photo {
            width: 100%;
            margin-bottom: 5px;
            padding-bottom: 100%;
            background-size: 90%;
            background-position: center;
            background-repeat: no-repeat;
            border: 2px solid #fff;
            position: relative;

            button {
                border: none;
                background-color: transparent;
                font-size: 30px;
                color: #fff;
                opacity: 0.5;
                position: absolute;
                outline: none;
                height: 100%;

                &.previous {
                    left: 0;
                    background: linear-gradient(to right, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0) 100%);
                    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#80000000', endColorstr='#00000000', GradientType=1);
                }

                &.next {
                    right: 0;
                    background: linear-gradient(to right, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.5) 100%);
                    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#00000000', endColorstr='#80000000', GradientType=1);
                }
            }
        }

        .thumbnails {
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(55px, 1fr));
            grid-gap: 4px;

            div {
                width: 35px;
                outline: 2px solid #ffffff;
                cursor: pointer;
                padding-bottom: 55%;
                background-size: contain;
                background-position: center;
                background-repeat: no-repeat;
                opacity: 1;

                &.active {
                    outline-color: $brand;
                    opacity: 1;
                }
            }
        }
    }

    @import url("https://fonts.googleapis.com/css?family=DM+Sans:400,500|Jost:400,500,600&display=swap");

    .bigpict {
        margin-top: 60px;
        height: 95%;
    }

    .littlepic {
        height: 120px;
    }

    .defect-image {
        display: inline-block;
        margin-right: 10px;
    }

    .card-box {
        font-family: "Jost", sans-serif;
        display: flex;
        flex-direction: column;
        background-color: rgba(16 18 27 / 10%);
        align-items: self-start;
        width: 100%;
        height: 100%;
    }

    .card {
        width: 98%;
        height: 98%;
        background-color: rgba(255, 255, 255, 1);
        display: flex;
        flex-direction: column;
        transition: 0.5s;
        border-radius: 10px;
        box-shadow: 0 0 0 8px rgba(255, 255, 255, 0.2);
        margin: 10px;
    }

    .card-header {
        position: relative;
        display: flex;
        height: 80px;
        flex-shrink: 0;
        width: 100%;
        transition: 0.5s;

        * {
            transition: 0.5s;
        }

        .card-avatar {
            width: 100px;
            height: 100px;
            box-shadow: 0 8px 8px rgba(0, 0, 0, 0.2);
            border-radius: 50%;
            object-position: center;
            object-fit: cover;
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%) translateY(-64px);
        }

        .card-fullname {
            position: absolute;
            bottom: 0;
            font-size: 22px;
            font-weight: 700;
            text-align: center;
            white-space: nowrap;
            transform: translateY(-10px) translateX(-50%);
            left: 50%;
        }

        .card-jobtitle {
            position: absolute;
            bottom: 0;
            font-size: 11px;
            white-space: nowrap;
            font-weight: 500;
            opacity: 0.7;
            text-transform: uppercase;
            letter-spacing: 1.5px;
            margin: 0;
            left: 50%;
            transform: translateX(-50%) translateY(-7px);
        }
    }

    .card.is-active {
        .card-header {
            height: 80px;
        }

        .card-avatar {
            transform: none;
            left: 20px;
            width: 50px;
            height: 50px;
            bottom: 10px;
        }

        .card-fullname,
        .card-jobtitle {
            left: 86px;
            transform: none;
        }

        .card-fullname {
            bottom: 18px;
            font-size: 19px;
        }

        .card-jobtitle {
            bottom: 16px;
            letter-spacing: 1px;
            font-size: 10px;
        }
    }

    .ss {
        cursor: pointer;
    }

    .card-main {
        display: flex;
        position: relative;
        //align-items: center;
        flex-direction: column;
        height: 100%;

        .card-section {
            display: none;

            &.is-active {
                display: flex;
                height: 100%;
                flex-direction: column;
                animation: fadeIn 0.6s both;
            }

            .card-content:first-child {
                overflow-y: hidden;
            }

            .card-content {
                padding: 20px;

                .card-subtitle {
                    font-family: "仿宋", serif;
                    font-weight: 300;
                    font-size: 20px;
                    margin-bottom: 8px;
                    color: #ffffff;
                    padding-top: 3px;
                    padding-left: 5px;
                    background-color: #5f50ebce;
                }

                //第一块
                .card-desc {
                    line-height: 1.6;
                    color: #161e22;
                    font-size: 14px;
                    margin: 0;
                    font-weight: 400;
                    font-family: "DM Sans", sans-serif;
                }

                //第二块
                .card-timeline {
                    margin-top: 30px;
                    position: relative;

                    .card-item {
                        position: relative;
                        padding-left: 60px;
                        padding-right: 20px;
                        padding-bottom: 30px;
                        z-index: 1;

                        &:last-child {
                            padding-bottom: 5px;
                        }

                        &:after {
                            content: attr(data-year);
                            width: 10px;
                            position: absolute;
                            top: 0;
                            left: 37px;
                            width: 8px;
                            height: 8px;
                            line-height: 0.6;
                            border: 2px solid #fff;
                            font-size: 11px;
                            text-indent: -35px;
                            border-radius: 50%;
                            color: rgba(#868686, 0.7);
                            background: linear-gradient(to bottom, color.adjust(#516acc, $lightness: 20%) 0%, #516acc 100%);
                        }

                        .card-item-title {
                            font-weight: 500;
                            font-size: 14px;
                            margin-bottom: 5px;
                        }

                        .card-item-desc {
                            font-size: 13px;
                            color: #6f6f7b;
                            line-height: 1.5;
                            font-family: "DM Sans", sans-serif;
                        }
                    }
                }

                //第三块
                .card-contact-wrapper {
                    margin-top: 20px;

                    .card-contact {
                        display: flex;
                        align-items: center;
                        font-size: 18px;
                        color: #d8a90d;
                        font-family: "DM Sans", sans-serif;
                        line-height: 1.6;
                        margin-bottom: 10px;

                        & + & {
                            margin-top: 16px;
                        }

                        img {
                            flex-shrink: 0;
                            width: 25px;
                            height: 25px;
                            transition: 0.3s;
                            margin-right: 10px;
                        }

                        span {
                            border-left: 1px solid #dfe2ec;
                            padding-left: 12px;
                        }
                    }

                    .contact-me {
                        border: 0;
                        outline: none;
                        background: linear-gradient(to right, rgba(83, 200, 239, 0.8) 0%, rgba(81, 106, 204, 0.8) 96%);
                        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.15);
                        color: #fff;
                        padding: 12px 16px;
                        border-radius: 5px;
                        margin-left: 55px;
                        cursor: pointer;
                        font-size: 14px;
                        font-weight: 500;
                        font-family: "Jost", sans-serif;
                        transition: 0.5s;
                    }
                }
            }

            //第一块
            .card-social {
                display: flex;
                align-items: center;
                padding: 0 20px;
                margin-bottom: 30px;

                svg {
                    fill: rgb(165, 181, 206);
                    width: 22px;
                    display: block;
                    transition: 0.5s;
                }

                a {
                    color: #8797a1;
                    height: 32px;
                    width: 32px;
                    border-radius: 50%;
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    transition: 0.5s;
                    background-color: rgba(93, 133, 193, 0.05);
                    margin-right: 10px;

                    &:hover {
                        svg {
                            fill: color.adjust(rgb(165, 181, 206), $lightness: -20%);
                        }
                    }

                    &:last-child {
                        margin-right: 0;
                    }
                }
            }
        }
    }

    .section-box {
        height: 90%;
        flex: 19;
    }

    //底部按钮
    .card-buttons {
        display: flex;
        flex: 1;
        background-color: #ffffff00;
        //width: 98%;
        z-index: 0;
        border-bottom-left-radius: 10px;
        border-bottom-right-radius: 10px;

        button {
            flex: 1 1 auto;
            user-select: none;
            background: 0;
            font-size: 13px;
            border: 0;
            padding: 15px 5px;
            cursor: pointer;
            color: #5c5c6d;
            transition: 0.5s;
            font-family: "Jost", sans-serif;
            font-weight: 500;
            outline: 0;
            border-bottom: 3px solid transparent;

            &.is-active,
            &:hover {
                color: #2b2c48;
                border-bottom: 3px solid #8a84ff;
                background: linear-gradient(to bottom, rgba(127, 199, 231, 0) 0%, rgba(207, 204, 255, 0.2) 44%, rgba(211, 226, 255, 0.4) 100%);
            }
        }
    }

    .firsttab {
        display: flex;
        padding: 2px 2px;
    }

    .basicinfo {
        width: 70%;
    }

    // 折线图
    .chartdiv {
        background-color: #f9ecc3;
        border-radius: 2%;
        padding: 20px;
        height: 530px;
    }

    :deep(.el-link.el-link--warning) {
        float: right;
    }

    .active {
        max-height: 200px;
    }

    .inactive {
        max-height: 400px;
    }

    .info-box {
        display: flex;
        flex-direction: row;
        height: 400px;
    }

    .info-box .left {
        flex: 2;
        padding-right: 15px;
    }

    .info-box .right {
        flex: 3;
        padding-left: 15px;
        width: 60%;
        border-left: 1px solid black;
    }

    .one-piece {
        height: 100%;
    }

    .block {
        display: block;
        width: 20px;
        height: 100%;
        background-color: #4095e5;
        margin-right: 10px;
    }

    .title-box {
        height: 100%;
        display: flex;
        flex-direction: row;
    }

    .ptj-choose-title,
    .now-choose-title {
        height: 50px;
        line-height: 50px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-direction: row;
        border: 2px solid lightgray;
    }

    .choose-title {
        padding: 10px 0;
        font-size: 20px;
        font-weight: 600;
    }

    .select-list {
        height: auto;
        padding: 5px;
        box-sizing: border-box;
    }

    .select-box {
        margin: 5px 0;
        height: 85%;
        overflow-y: auto;
        background-color: #f9f9f9;
        border: 1px solid #bdbdbd;
    }

    .one-choose .el-select__wrapper {
        width: 80% !important;
    }

    .order {
        display: flex;
        justify-content: right;
    }

    .one-choose {
        padding: 5px 0 5px 20px;
        display: flex;
        flex-direction: row;
        width: 90%;
    }

    .one-choose .title {
        margin: 0 5px;
        flex: 1;
    }

    .one-choose .select {
        flex: 4;
    }

    :deep(.el-table .cell) {
        color: #333;
    }
</style>
